import {ref} from 'vue';

const initialReservationData = {
    contactPerson: {
        name: '',
        phoneNumber: '',
        email: ''
    },
    exhibitorDetails: {
        companyName: '',
        streetName: '',
        houseNumber: '',
        postcode: '',
        cityName: '',
        website: ''
    },
    billing: {
        chamberOfCommerceNumber: '',
        streetName: '',
        houseNumber: '',
        postcode: '',
        cityName: '',
        email: '',
        deliveryMethod: 'by_email',
        vatNumber: '',
        description: '',
    },
    additionalExhibitors: []
}

const reservationData = ref({...initialReservationData});

export default function useReservationData() {
    const clearReservationData = () => {
        reservationData.value = {...initialReservationData};
    }

    const addAdditionalExhibitor = () => {
        const newExhibitor = {
            id: Date.now(), // Simple ID generation
            contactPerson: '',
            email: '',
            companyName: '',
            phoneNumber: '',
            website: ''
        };
        reservationData.value.additionalExhibitors.push(newExhibitor);
    }

    const removeAdditionalExhibitor = (id) => {
        const index = reservationData.value.additionalExhibitors.findIndex(exhibitor => exhibitor.id === id);
        if (index > -1) {
            reservationData.value.additionalExhibitors.splice(index, 1);
        }
    }

    const updateAdditionalExhibitor = (id, field, value) => {
        const exhibitor = reservationData.value.additionalExhibitors.find(exhibitor => exhibitor.id === id);
        if (exhibitor) {
            exhibitor[field] = value;
        }
    }

    const getAdditionalExhibitorsCost = () => {
        return reservationData.value.additionalExhibitors.length * 25; // 25 EUR per additional exhibitor
    }

    return { 
        reservationData, 
        clearReservationData, 
        addAdditionalExhibitor, 
        removeAdditionalExhibitor, 
        updateAdditionalExhibitor,
        getAdditionalExhibitorsCost
    };
}
